import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";

export default function CustomPrinting() {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Custom Printed Paper Packaging",
        serviceType: "Custom paper packaging printing",
        description: "Custom-printed paper salad bowls, soup bowls, kraft containers and PET-lid packaging with 1–6 colour flexo/offset printing. MOQ from 10,000 pieces. Design guidelines and plate-making handled in-house.",
        areaServed: [{ "@type": "Country", name: "India" }, { "@type": "Country", name: "United Arab Emirates" }, { "@type": "Country", name: "United Kingdom" }, { "@type": "Country", name: "Saudi Arabia" }],
        provider: { "@type": "Organization", "@id": "https://thepuropack.com/#organization", name: "The Puro Pack", url: "https://thepuropack.com" },
        audience: { "@type": "BusinessAudience", audienceType: "Restaurants, QSR chains, cloud kitchens, cafés, food brands" },
    };
    return (
        <div data-testid="custom-printing-page">
            <Seo title="Custom Printing" description="Print-forward packaging for cloud kitchens, QSRs and cafés. Up to 6-colour offset & flexo. Small MOQs. Design guidelines included." path="/custom-printing" schema={schema} />
            <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
                <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Custom Printing", to: "/custom-printing" }]} />
            </div>

            <section className="max-w-[1600px] mx-auto px-6 lg:px-10 pt-14 pb-20 grid lg:grid-cols-12 gap-10 items-start">
                <div className="lg:col-span-7">
                    <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Print Studio ]</div>
                    <h1 className="font-serif text-6xl lg:text-8xl leading-[0.92] tracking-tight text-forest">
                        Your brand, on <em className="italic">everything</em> the meal touches.
                    </h1>
                    <p className="mt-8 text-inkgreen/80 leading-relaxed max-w-2xl">
                        For a cloud kitchen, the packaging <em>is</em> the storefront. We run full 6-colour offset and precision flexo — PE-free surfaces, MOQs from 20,000 units.
                    </p>
                </div>
                    <div className="lg:col-span-5">
                        <div className="image-frame aspect-[4/5]">
                            <img src="https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/4zrx24td_Untitled-11.webp" alt="Custom printed paper packaging — Gelato ice-cream cup by The Puro Pack" loading="lazy" />
                        </div>
                    </div>
            </section>

            <section className="bg-sand border-y border-forest">
                <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24">
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-forest/40">
                        {[
                            ["MOQ", "20,000 units"],
                            ["Colours", "Up to 6 · CMYK + 2 spot"],
                            ["Turnaround", "10–14 days from plate approval"],
                            ["Files", "Vector · CMYK · 300dpi"],
                        ].map(([k, v]) => (
                            <div key={k} className="border-r border-b border-forest/40 p-8">
                                <div className="font-mono text-xs uppercase tracking-widest text-stone mb-3">{k}</div>
                                <div className="font-serif text-3xl text-forest">{v}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                    <div className="font-mono text-xs uppercase tracking-widest text-stone mb-4">[ Design Guidelines ]</div>
                    <h2 className="font-serif text-4xl lg:text-5xl text-forest tracking-tight">Five rules we ask of every artwork file.</h2>
                </div>
                <div className="lg:col-span-8">
                    {[
                        ["01", "Send us vector (.ai / .pdf). Flattened raster degrades under rotogravure."],
                        ["02", "CMYK, not RGB. Screens lie. Presses tell the truth."],
                        ["03", "Type ≥ 8pt. Anything smaller loses stroke at high speed."],
                        ["04", "Avoid full-bleed dark solids on food-contact surfaces."],
                        ["05", "Add 3mm bleed and mark your die-cut lines clearly."],
                    ].map(([n, t]) => (
                        <div key={n} className="border-t border-forest/30 py-6 flex gap-8">
                            <div className="font-mono text-clay text-xl w-12">[{n}]</div>
                            <div className="text-inkgreen/80 text-lg font-serif italic">{t}</div>
                        </div>
                    ))}
                    <Link to="/contact" className="btn-pill btn-solid mt-10" data-testid="custom-print-cta">Start a Print Project →</Link>
                </div>
            </section>
        </div>
    );
}
